/* VELTRA hero image pin — 2026-10-22
   主题的 hero 图 srcset 带 3840w 候选，浏览器在 2x 屏会选它，
   而 Shopify CDN 对 &width=3840 的请求返回的是 900px 位图（实测 naturalWidth=900），
   于是首屏在视网膜屏上被放大成糊的。这里把 hero 图的 src/srcset 钉到
   与 DPR 匹配的真实宽度上，浏览器拿到的就是实打实的分辨率。 */
(function () {
  var DESKTOP = [1200, 1600, 1920, 2560];
  var MOBILE = [832, 1000];

  function pick(list, need) {
    for (var i = 0; i < list.length; i++) {
      if (list[i] >= need) return list[i];
    }
    return list[list.length - 1];
  }

  function pin() {
    var imgs = document.querySelectorAll('.hero picture.hero__media img, .hero img.hero__media');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.dataset.veltraPinned) continue;
      var src = img.currentSrc || img.src;
      if (!src || src.indexOf('/cdn/') === -1) continue;
      var box = img.getBoundingClientRect();
      var dpr = window.devicePixelRatio || 1;
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var need = Math.round((box.width || (isMobile ? 390 : 1440)) * dpr);
      var width = pick(isMobile ? MOBILE : DESKTOP, need);
      var base = src.split('?')[0];
      var v = (src.match(/[?&]v=(\d+)/) || [])[1];
      var url = base + '?width=' + width + (v ? '&v=' + v : '');

      img.removeAttribute('srcset');
      img.setAttribute('sizes', isMobile ? '100vw' : '100vw');
      img.src = url;
      var pic = img.parentNode;
      if (pic && pic.tagName === 'PICTURE') {
        var sources = pic.querySelectorAll('source');
        for (var k = 0; k < sources.length; k++) sources[k].removeAttribute('srcset');
      }
      img.dataset.veltraPinned = String(width);
    }
  }

  /* 主题的 .button:hover 会把 --color-primary-button-hover-background 解析成空，底色变透明。
     用内联 !important 直接钉住 Clay 实底 + 棕边，鼠标进出还原。 */
  var CLAY = '#A6522F';
  var CLAY_DARK = '#8A4225';

  function paint(el, hover) {
    var bg = hover ? CLAY_DARK : CLAY;
    el.style.setProperty('background-color', bg, 'important');
    el.style.setProperty('border-color', bg, 'important');
    el.style.setProperty('color', '#FFFFFF', 'important');
    el.style.setProperty('opacity', '1', 'important');
  }

  function bindButtons() {
    var btns = document.querySelectorAll('.hero a.button, .hero button.button, .hero .button');
    for (var i = 0; i < btns.length; i++) {
      var el = btns[i];
      if (el.dataset.veltraHover) continue;
      el.dataset.veltraHover = '1';
      paint(el, false);
      el.addEventListener('mouseenter', function () { paint(this, true); });
      el.addEventListener('mouseleave', function () { paint(this, false); });
      el.addEventListener('focus', function () { paint(this, true); });
      el.addEventListener('blur', function () { paint(this, false); });
      el.addEventListener('touchstart', function () { paint(this, true); }, { passive: true });
      el.addEventListener('touchend', function () { paint(this, false); });
    }
  }

  function run() {
    pin();
    bindButtons();
    // 主题会在 resize / 变体切换时重置 srcset，再兜两轮
    setTimeout(pin, 900);
    setTimeout(pin, 2500);
    setTimeout(bindButtons, 1200);
    window.addEventListener('resize', function () {
      setTimeout(pin, 400);
      setTimeout(bindButtons, 500);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
